import { apiRequest } from '@/api/request.js'
export const getAttachmentById = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/attach_file/get_file_by_id',
    method: 'GET'
  })
}
export const getBatchPreSignUrls = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/ua/oss/get_batch_pre_sign_url',
    method: 'GET'
  })
}
export const getQrcodeTicketContent = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/ua/qrcode_ticket/get_content',
    method: 'GET'
  })
}
export const getMiniQrcodeTicket = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/ua/qrcode_ticket/mini_qrcode',
    method: 'GET'
  })
}
export const getShopImChannelInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/wukongim/get_shop_channel_info?shopId=' + params?.data.shopId,
    method: 'POST'
  })
}
export const listImChannelSubscribers = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/wukongim/list_channel_subcribers',
    method: 'GET'
  })
}
export const syncImConversationPage = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/wukongim/conversation/sync/page',
    method: 'GET'
  })
}
export const listUnreadNotifyLogCounts = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/notify_log/unread_count_list',
    method: 'GET'
  })
}
export const saveAttachmentToPlatform = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/attach_file/save_to_platform',
    method: 'POST'
  })
}
export const uploadMinio = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/ua/oss/upload_minio',
    method: 'POST'
  })
}
export const getUploadMinioOptions = (params = {}) => {
  return {
    ...params,
    url: '/mall4cloud_biz/ua/oss/upload_minio'
  }
}
export const createShopImChannel = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/wukongim/create_channel?shopId=' + params?.data.shopId,
    method: 'POST'
  })
}
export const sendImAutoReply = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/wukongim/send_auto_reply?channelId=' + params?.data.channelId,
    method: 'POST'
  })
}
export const replaceSensitiveContent = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/ua/sensitive/replace',
    method: 'POST'
  })
}
export const syncImChannelMessages = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/wukongim/channel/message_sync',
    method: 'POST'
  })
}
export const setImConversationUnread = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/wukongim/conversations/set_unread',
    method: 'POST'
  })
}
export const registerOrLoginImAccount = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/wukongim/register_or_login',
    method: 'POST'
  })
}
export const sendImAutoReplyContent = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/wukongim/send_auto_reply_content',
    method: 'POST'
  })
}
export const updateImChannel = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/wukongim/update_channel',
    method: 'POST'
  })
}
export const updatePasswordBySmsCode = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/sms/verification_code/update_pwd',
    method: 'PUT'
  })
}
export const sendPublicUpdatePasswordSmsCode = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/ua/sms/verification_code/update_pwd',
    method: 'PUT'
  })
}
export const sendLoginSmsCode = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/ua/sms/verification_code/login_code',
    method: 'PUT'
  })
}
export const validateUpdatePasswordSms = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/sms/verification_code/check_update_pwd',
    method: 'PUT'
  })
}
export const validatePublicUpdatePasswordSms = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/ua/sms/verification_code/check_update_pwd',
    method: 'PUT'
  })
}
export const sendUserCardSmsCode = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/sms/verification_code/userCard?telephone=' + params?.data.telephone,
    method: 'PUT'
  })
}
export const verifyUpdatePhoneSms = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/ua/sms/verification_code/checkUpdatePhoneSms',
    method: 'PUT'
  })
}
export const validateSmsVerificationCode = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_biz/ua/sms/verification_code/valid',
    method: 'PUT'
  })
}
